import { createDarkTheme } from "../../utils/createDarkTheme.js";
import { brandWeb } from "../../global/brandColors.js";
export const webDarkTheme = createDarkTheme(brandWeb);
